import React, { Component } from "react";
import FormInputs from "../../components/UI/FormInputs";
import Buttons from "../../components/UI/Buttons";
import TableGrid from "../../components/UI/TableGrid";
import { convertUnderScoreStrings, isObject, isSet, toQueryString } from "../../utils/commonUtils";
import WithRoutify from "../../hoc/WithRoutify";
import withReduxState from "../../hoc/wReduxState";
import WithRouter from "../../hoc/WithRouter";
import TableSkeleton from "../../hoc/TableSkeleton";
import PERMISSIONS from "../../utils/AclPermissions";
import VideoConfigService from "../../services/VideoConfigService";
import NotificationTemplateService from "../../services/NotificationTemplateService";
import AddNotificationTemplate from "./AddNotificationTemplate";
import MessageModal from "../NotificationContainer/MessageModal";
import NotificationMessageModal from "./NotificationMessageModal";

class NotificationTemplateList extends Component {
  state = {
    importModalOpen: false,
    importType: ''
  };

  importModalHandler = (type) => {
    this.setState({
      importModalOpen: !this.state.importModalOpen, // toggle open/close
      importType: type
    });
  };
  constructor(props) {
    super(props);
    // Initialize state or bind methods if needed
    const tableHeaders = [
      {
        label: "",
        key: "isActive",
        type: "checkBox",
        changeHandler: this.checkBoxchangeHandler,
      },
      {
        label: "Template Name",
        key: "notification_name",
        type: "",
        inputType: "TextInput",
        sortName: "notification_name",
      },
       {
        label: "Template Type",
        key: "notification_type",
        type: "",
        inputType: "TextInput",
      },
        {
        label: "Template List Type",
        key: "notification_list_type",
        type: "",
        inputType: "TextInput",
        type:"Actions"
      },
      { label: "Action", key: "action", type: "Actions" },
      //  more columns as needed
    ];
    this.state = {
      filters: {
        search_query: "",
      },
      tableRecords: {
        tableHeaders: tableHeaders,
        tableRows: {
          status: 200,
          data: [],
        },
        pagination: {
          page: 1,
          perPage: 25,
          totalRecords: 0,
          sort_by: "notification_name",
          sort_order: "asc",
          search: {},
        },
      },
      formDataInEdit: {},
      activeEditId: null,
      organizationOption: [],
      clinicOptions: [],
      // Your state variables go here
      isModelOpen: false,
      organization_id: "",
      messageModelOpen:false,
      activeMessageLog:null
    };
  }

  componentDidMount() {
    // let userProfile

    // const fetchList = async () => {
    //   await this.fetchIcdList();
    // };
    // fetchList();
    this.fetchList()
    // Code to run after the component has mounted
  }

  componentDidUpdate = (prevProps, prevState) => {
    // console.log('logs',this.props);
    // Code to run after the component has updated
  };

  componentWillUnmount() {
    // Code to run before the component is unmounted
  }

  handleEvent = () => {
    // Handler for events (e.g., button click)
  };
  addFormHandler = (isedit=false) => {
    if(isedit){
    this.setState({ isModelOpen: !this.state.isModelOpen });
    }else{
      this.setState({ isModelOpen: !this.state.isModelOpen,formDataInEdit:{},activeEditId:"" });
    }
  };

  onChangeFiltersHandler = (key, val) => {
    const { filters } = this.state;
    this.setState({
      filters: {
        ...filters,
        [key]: val,
      },
    });
  };
  render() {
    const { tableRecords,messageModelOpen,formDataInEdit, filters, isModelOpen, activeEditId ,importModalOpen} = this.state;
    return (
      <>
        {
          messageModelOpen ?
            <NotificationMessageModal
              data={this.state.activeMessageLog}
              addFormHandler={this.messageFormHandler}
              Loader={this.props.Loader}
            />
            :
            ''
        }
        {isModelOpen ? (
          // <VideoPlayer />
          <AddNotificationTemplate
            modelTitle={`${this.state.activeEditId ? "Update" : "Add"} Notification Template`}
            isOpen={this.state.isModelOpen}
            fetchList={this.fetchList}
            addFormHandler={this.addFormHandler}
            activeEditId={activeEditId}
            Loader={this.props.Loader}
            formDataInEdit={formDataInEdit}
          />
        ) : (
          <></>
        )}

        <TableSkeleton
          tableRecords={tableRecords}
          addFormHandler={this.addFormHandler}
          acl={PERMISSIONS.NOTIFICATION_TEMPLATE.CREATE}
          content={"Notification Template List"}
        >
          <div className="sh_cardBox sh_cardbglight">
            <div className="sh_cardHeader">
              <div className="form-group d-flex mb-0 justify-content-between align-items-center formheader">
                <h6 class="text-lg f-500 mb-0">Notification Template configure List </h6>
                <div className="d-flex">
                  <div className="form-group-fields row mr-2">
                    <div className="col-12 px-1 d-flex">
                      <div className="input-group input-group-joined input-group-solid">
                        <FormInputs
                          placeholder="Search"
                          value={filters["search_query"]}
                          changeHandler={(val) =>
                            this.onChangeFiltersHandler("search_query", val)
                          }
                          className="form-control"
                        />
                      </div>
                      <div className="btn-group pl-2">
                        <button
                          className="btn btn-primary"
                          onClick={() => this.submitFiltersHandler()}
                        >
                          Search
                        </button>
                        <button
                          className="btn btn-outline-secondary"
                          onClick={() => this.clearFiltersHandler()}
                        >
                          Clear
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="addAction">
                    <div className="btn-group">
                      <Buttons
                        clickHandler={() => {
                          this.addFormHandler();
                          this.setState({ activeEditId: "" });
                        }}
                        className="btn btn-primary"
                        acl={PERMISSIONS.NOTIFICATION_TEMPLATE.CREATE}
                        label={"Add"}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="sh_cardBody p-0">
              <TableGrid
                addFormHandler={() => this.addFormHandler()}
                hasPagination={true}
                fetchTableRecords={(filters) => this.fetchList(filters)}
                {...tableRecords}
              />
            </div>
          </div>
        </TableSkeleton>
      </>
    );
  }
  submitFiltersHandler = async () => {
    const { filters, tableRecords } = this.state;
    const queryfilters = {
      ...tableRecords.pagination,
      page: 1,
      search: filters,
    };
    this.fetchList(queryfilters);
  };
  clearFiltersHandler = async () => {
    await this.setState({
      filters: {},
    });
    this.submitFiltersHandler();
  };
  messageFormHandler=(messageLog={})=>{
    this.setState({
      messageModelOpen:!this.state.messageModelOpen,
      activeMessageLog:messageLog,
    });
  }
  fetchList = async (query = {}) => {
    const { tableRecords } = this.state;
    try {
      const queryString = toQueryString({
        ...tableRecords.pagination,
        ...query,
      });
      this.props.Loader(true);
      const response = await NotificationTemplateService.getList(null,queryString);
      console.log("response", response);

      const tableData = response?.data.data.map((data, companyIndex) => ({
        companyIndex: companyIndex,
        isHeading: false,
        rowId: data.notification_template_id,
        data: {
          isActive: false,
          notification_name: data.notification_name,
          notification_type: data.notification_type,
          notification_list_type:
            [{
              title: 'notification list type',
              label: data.notification_list_type,
              clickHandler: () => this.messageFormHandler(data),
              acl: PERMISSIONS.NOTIFICATION_TEMPLATE.LIST,
            }],
          active: "Yes",
          action: [
            {
              className: "btn btn-icon btn-transparent-dark",
              iconType: "Search",
              title: "View",
              type: "GridEdit",
              acl: PERMISSIONS.NOTIFICATION_TEMPLATE.EDIT,
              clickHandler: (rowId, data) => this.editHandler(rowId, data,false),
            },
            {
              className: "btn btn-icon btn-transparent-dark",
              iconType: "Copyicon",
              acl: PERMISSIONS.NOTIFICATION_TEMPLATE.CREATE,
              title: "Copy",
              clickHandler: () => this.editHandler(data.notification_template_id, data, true),
            },
            {
              className: "btn btn-icon btn-transparent-dark",
              iconType: "Remove",
              acl: PERMISSIONS.NOTIFICATION_TEMPLATE.DELETE,
              title: "Delete",
              isDelete: true,
              clickHandler: () => this.deleteHandler(data.notification_template_id),
            },
          ],
        },
      }));
      // console.log('tableData',response?.data);
      this.setState((prevState) => ({
        tableRecords: {
          ...prevState.tableRecords,
          tableHeaders: prevState.tableRecords.tableHeaders,
          tableRows: {
            type: "default",
            status: 200,
            data: tableData,
          },
          pagination: {
            ...prevState.tableRecords.pagination,
            ...query,
            totalRecords: response?.data?.total,
          },
        },
      }));
    } catch (err) {
      this.setState({
        tableRecords: {
          ...tableRecords,
          tableRows: {
            ...tableRecords.tableRows,
            status: 200,
          },
        },
      });
      console.log("DataIsse");
      // console.error("Error fetching companies:", err);
    } finally {
      this.props.Loader(false);
    }
  };

  deleteHandler = async (id) => {
    try {
      this.props.Loader(true);
      NotificationTemplateService.deleteTemplate(null,id)
        .then((res) => {
          this.fetchList();
          this.props.Toast.success("Template Deleted Succesfully");
        })
        .catch((err) => {
          //
        })
        .finally(() => {
          //
          this.props.Loader(false);
        });
    } catch (err) {
      console.log(err);
      this.props.Loader(false);
    };
  }
  editHandler = (rowId, data,copy=false) => {    
    this.setState(
      {
        formDataInEdit:copy?data:{},
        activeEditId: copy?null:rowId,
      },
      this.addFormHandler(true)
    );
  };

  checkBoxchangeHandler = (value, e, rowId) => {
    const { tableRows } = this.state.tableRecords;

    const updatedData = tableRows.data.map((item) => {
      if (item.rowId === rowId) {
        item.data.isActive = value;
      }
      return item;
    });

    this.setState((prevState) => ({
      tableRecords: {
        ...prevState.tableRecords,
        tableRows: {
          ...prevState.tableRecords.tableRows,
          data: updatedData,
        },
      },
    }));
  };
}
export default WithRouter(withReduxState(WithRoutify(NotificationTemplateList)));
